import { User } from '../user';

export class AuthMock {

  token = 'token-mock'
}
